import { request } from '@/utils/request'
const ProjectManageService = {
  state: {},

  mutations: {},

  actions: {
    // 项目分页
    GetAllProject({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.get('Equipment/Project/GetAllProject', params).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 保存项目
    SaveProject({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.post('Equipment/Project/SubmitForm?keyValue=' + params.keyValue, params.formData).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 删除项目
    DeleteProject({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.post('Equipment/Project/DeleteByObjectID', params).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 根据机构id获取项目
    GetProjectListByOrganizeID({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.get('/api/equipment/v1/GetProjectListByOrganizeID', params).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
  }
}
export default ProjectManageService
